<template>
    <b-navbar-item style="min-width:100%; margin: 0" tag="router-link" :to="{ path: '/' }">
        <img v-if="this.apps && this.apps.webAdminLogo" :src="this.apps.webAdminLogo" alt="">
        <img v-else src="/static/images/neoslide_icon.png" alt="">
        <img v-if=" this.apps && this.apps.webAdminTextLogo" :src="this.apps.webAdminTextLogo" alt="">
        <img v-else src="/static/images/name.png" alt="">
  </b-navbar-item>
</template>

<script>

export default {
  name: 'Logos',
  computed: {
    apps () {
      return this.$store.state.apps
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logos.vue